<script>
import Layout from "@/components/pages/layouts/auth";
import { mapActions, mapState } from "vuex";
import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      email: "",
      password: "",
      otpCode: "",
      otpVerified: false,
      submitted: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  computed: {
    ...mapState('notification', {
      notificationType: state => state.type,
      notificationMessage: state => state.message
    })
  },
  methods: {
    ...mapActions('auth', ['logIn', "verifyOtp"]),
    tryToLogIn() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        const { email, password } = this;
        if (email && password) {
          this.logIn({ email, password }).then(() => {
          this.otpVerified = true; // Show OTP verification form
        });
        }
      }
    },
    verifyOTP() {
      this.verifyOtp(this.otpCode).then(() => {
        this.otpVerified = false; // Hide OTP verification form after success
      }).catch(error => {
        console.error('OTP verification error:', error);
      });
    },
  },
};
</script>

<template>
  <Layout>
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6 col-xl-5">
      <div class="card overflow-hidden">
        <div class="bg-soft bg-primary">
          <div class="row">
            <div class="col-7">
              <div class="text-primary p-4">
                <h5 class="text-primary">Welcome Back !</h5>
                <p>Sign in to continue to manage your properties.</p>
              </div>
            </div>
            <div class="col-5 align-self-end">
              <img
                src="@/assets/images/profile-img.png"
                alt
                class="img-fluid"
              />
            </div>
          </div>
        </div>
        <div class="card-body pt-0">
          <div>
            <div class="avatar-md profile-user-wid mb-4">
              <span class="avatar-title rounded-circle bg-light">
                <img src="@/assets/images/mpv-logo-small.png" alt height="32" />
              </span>
            </div>
          </div>
          <div v-if="notificationMessage" :class="'alert ' + notificationType">
            {{ notificationMessage }}
          </div>
          <div v-if="!otpVerified">
          <b-form class="p-2" @submit.prevent="tryToLogIn">
            <b-form-group class="mb-3" id="input-group-1" label="Email" label-for="input-1">
              <b-form-input
                id="input-1"
                v-model="email"
                type="text"
                placeholder="Enter email"
                :class="{ 'is-invalid': submitted && $v.email.$invalid }"
              ></b-form-input>
              <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                <span v-if="!$v.email.required">Email is required.</span>
                <span v-if="!$v.email.email">Please enter valid email.</span>
              </div>
            </b-form-group>

            <b-form-group class="mb-3" id="input-group-2" label="Password" label-for="input-2">
              <b-form-input
                id="input-2"
                v-model="password"
                type="password"
                placeholder="Enter password"
                :class="{ 'is-invalid': submitted && $v.password.$error }"
              ></b-form-input>
              <div v-if="submitted && !$v.password.required" class="invalid-feedback">
                Password is required.
              </div>
            </b-form-group>
            <b-form-checkbox
              class="form-check"
              id="customControlInline"
              name="checkbox-1"
              value="accepted"
              unchecked-value="not_accepted"
            >
              Remember me
            </b-form-checkbox>
            <div class="mt-3 d-grid">
              <b-button type="submit" variant="primary" class="btn-block">Log In</b-button>
            </div>
            <div class="mt-4 text-center">
              <router-link to="/forgot-password">
                <i class="mdi mdi-lock me-1"></i> Forgot your password?
              </router-link>
            </div>
          </b-form>
          </div>
          <div v-else>
            <!-- OTP verification form -->
            <form @submit.prevent="verifyOTP">
              <p>OTP code sent to <strong>{{email}}</strong></p>
              <input type="number" min="000000" v-model="otpCode" placeholder="Enter OTP code" required>
              <button type="submit">Verify OTP</button>
            </form>
          </div>
        </div>
        <!-- end card-body -->
      </div>
      <!-- end card -->

      <div class="mt-5 text-center">
        <p>
          © {{ new Date().getFullYear() }} My Property Vault
        </p>
      </div>
      <!-- end row -->
    </div>
    <!-- end col -->
  </div>
  <!-- end row -->
  </Layout>
</template>
<style scoped >
/* Chrome, Safari, Edge, Opera */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>